module.exports = __webpack_public_path__ + "static/media/1.8.5a0de468.png";